import styled from 'styled-components';

export default styled.img.attrs({
  id: props => props.id || '',
  src: props => {
    let imageSrc = props.theme.background || props.src || '';
    if (props.isMainMenu) {
      imageSrc = props.theme.menu_background;
    } else if (props.isIPG) {
      imageSrc = props.theme.ipg_background;
    } else if (props.isWelcomeVIW) {
      imageSrc = props.theme.welcome_background;
    }
    return imageSrc;
  }
})`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;
